module.exports = __webpack_public_path__ + "img/process.a20dbbf9.png";